// src/utils/functions.tsx
function identity(t) {
  return t;
}
function identityArgs(...args) {
  return args;
}
export {
  identity,
  identityArgs
};
//# sourceMappingURL=functions.js.map